const OddsSection = ({ ftLabel, title, children, isFirstHalf, isFirstSection, showTitle }) => {
  return (
    <div
      className={`flex flex-none md:flex-1 flex-col justify-start ml-0 ${isFirstSection ? "md:ml-0" : isFirstHalf ? "md:ml-[25px]" : "md:ml-3"}`}
    >
      <div className={`flex flex-initial flex-col items-center justify-center text-center text-base ${showTitle ? "h-[35px]" : "invisible h-[25px]"}`}>
        <span className="text-nowrap text-[12px] md:text-base text-[var(--theme-text)]">{ftLabel}</span>
        <span className="text-nowrap text-[12px] md:text-base text-[var(--theme-text)]">{title}</span>
      </div>
      <div className="mt-[50px] md:mt-[59px] flex flex-1 flex-col">{children}</div>
    </div>
  );
};

export default OddsSection;
